import gql from 'graphql-tag';

export const EHRENAMTLICHE_FINDEN_HEADER_FRAGMENT = gql`
fragment ehrenamtlicheFindenHeader on EhrenamtlicheFindenHeaderType {
    headerImage
    headerTitle
    headerButtonTextOne
    headerButtonUrlOne
    headerButtonTextTwo
    headerButtonUrlTwo
    id
  }
`;